module.exports = __webpack_public_path__ + "img/IT0001124022432.3d96b9a4.png";